/* ===========================================================================
   Arvensis Professional — LP da loja internacional oficial dentro da MKPBR
   Criada em 18/09/2026 no molde da Gold Spell v2: prateleiras, ficha do
   produto, carrinho proprio, busca local, seletores e faixa de mercado.

   DEGRAUS DO DESCONTO: 2 itens = 5%, 3 = 10%, 4+ = 15%, contando o TOTAL DE
   ITENS DO CARRINHO (soma produtos diferentes). Quem APLICA e o app Pumper,
   no servidor — esta pagina so mostra. Os degraus vem do #av-cfg.

   LINHAS por PALAVRA DO HANDLE (o handle nao e traduzido; o titulo e), nos
   nomes que a propria marca usa no menu "Linhas" do site oficial.

   v2 (22/09/2026): pagina reorganizada para vender — carrossel do topo em
   alta, quiz "Qual e o seu cabelo?", "Monte sua rotina", "Complete a rotina"
   e "Tamanho salao 1 L". Bloco RECURSOS DE VENDA, mais abaixo.
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };

  /* ---------- dados ------------------------------------------------------ */
  function readJSON(id, fallback) {
    var el = D.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[arvensis] JSON invalido em #' + id, e); return fallback; }
  }
  var CFG = readJSON('av-cfg', {});
  var RAW = readJSON('av-data', []);

  /* O Liquid devolve numero como texto em varios campos (a nota chega como
     "4.9"). Converte UMA vez, logo depois de ler o JSON. */
  function normVar(v) {
    v.pr = Number(v.pr) || 0;
    v.prf = String(v.prf == null ? '' : v.prf);
    v.cmpf = v.cmpf ? String(v.cmpf) : null;
    v.av = v.av === true || v.av === 'true';
    v.t = String(v.t == null ? '' : v.t);
    return v;
  }
  function prepara(lista) {
    return (lista || []).filter(function (p) { return p && p.h && p.v && p.v.length; }).map(function (p) {
      p.v = p.v.map(normVar);
      p.img = Array.isArray(p.img) ? p.img.filter(function (i) { return i && i.s; }) : [];
      p.tags = Array.isArray(p.tags) ? p.tags : [];
      p.rr = p.rr == null ? null : parseFloat(p.rr);
      if (!isFinite(p.rr)) p.rr = null;
      p.rc = Math.round(parseFloat(p.rc) || 0);
      p.c = String(p.c || '');
      p.av = p.v.some(function (v) { return v.av; });
      var disp = p.v.filter(function (v) { return v.av; });
      var base = (disp.length ? disp : p.v).slice().sort(function (a, b) { return a.pr - b.pr; });
      p.min = base[0];
      /* "a partir de" so quando os precos REALMENTE diferem */
      p.faixa = p.v.length > 1 && p.v.some(function (v) { return v.pr !== p.v[0].pr; });
      p.multi = p.v.length > 1;
      p.fam = familia(p);
      p.isKit = ehKit(p);
      p.isNew = !!(CFG.newSince && p.c && p.c >= String(CFG.newSince));
      return p;
    });
  }

  /* ---------- idiomas ----------------------------------------------------
     O texto FIXO da pagina sai pronto do servidor (snippets/arvensis-i18n).
     Aqui chegam so as chaves que este arquivo usa, ja no idioma do mercado. */
  var ISO = CFG.iso || D.documentElement.lang || 'en';
  var PACK = readJSON('av-i18n', {});
  function t(k) { return PACK[k] || ''; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmtNum(n) {
    try { return new Intl.NumberFormat(ISO + '-u-nu-latn').format(n); } catch (e) { return String(n); }
  }

  /* ---------- dinheiro --------------------------------------------------- */
  /* Moeda do MERCADO desde o primeiro desenho (a v1 comecava em USD e so
     corrigia depois do /cart.js: a soma da rotina saia em dolar no Japao). */
  var CURRENCY = CFG.cur || 'USD';
  /* SO no carrinho: o /cart.js entrega a moeda do mercado. Nos cards e na
     ficha usamos v.prf, que o Liquid ja formatou. */
  /* Mesmo formato do Liquid (| money) nos cards e no carrinho: o #av-cfg traz
     12345,67 ja formatado pela loja (ex.: "Dhs. 12,345.67", "12.345,67 €",
     "¥12,346"); daqui sai o simbolo, a posicao e os separadores. */
  var MF = (function (tpl) {
    var m = /\d[\d.,'\s\u00a0\u202f]*\d/.exec(String(tpl || ''));
    if (!m) return null;
    var num = m[0], dec = /([.,])\d{2}$/.exec(num), mil = /^12(\D+)34/.exec(num);
    return { pre: tpl.slice(0, m.index), pos: tpl.slice(m.index + num.length), dec: dec ? dec[1] : '', sep: mil ? mil[1] : '' };
  })(CFG.mfmt);
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    if (MF && CURRENCY === CFG.cur) {
      var casas = MF.dec ? 2 : 0, fix = n.toFixed(casas).split('.');
      var inteiro = fix[0].replace(/\B(?=(\d{3})+(?!\d))/g, MF.sep);
      return MF.pre + inteiro + (casas ? MF.dec + fix[1] : '') + MF.pos;
    }
    try { return new Intl.NumberFormat(ISO, { style: 'currency', currency: CURRENCY }).format(n); }
    catch (e) { return CURRENCY + ' ' + n.toFixed(2); }
  }
  function parseMoney(s) {
    var n = String(s == null ? '' : s).replace(/[^\d.,]/g, '');
    if (!n) return NaN;
    var dec = /[.,](\d{1,2})$/.exec(n);
    if (dec) return parseFloat(n.slice(0, n.length - dec[0].length).replace(/[.,]/g, '') + '.' + dec[1]);
    return parseFloat(n.replace(/[.,]/g, ''));
  }

  /* ---------- linhas (familias) ---------------------------------------------
     A ordem dos testes importa: Rodrigo Vizu e Cachinhos (kids) antes de
     Cachos; Tec Oil, Reconstrucao e Anti Quebra pelo nome da linha no handle;
     o resto (Anti Residuos, BB Hair Revolution, Acidificante, kit de
     cronograma) cai em Tratamentos. */
  var FAMILIAS = ['cachos', 'kids', 'tecoil', 'recon', 'anti', 'vizu', 'treat'];
  function tagSet(p) { return p.tags.map(function (x) { return String(x).toLowerCase(); }); }
  function familia(p) {
    var h = String(p.h).toLowerCase();
    var tg = tagSet(p);
    if (/rodrigo-vizu/.test(h)) return 'vizu';
    if (/cachinhos/.test(h) || tg.indexOf('baby / kids') > -1) return 'kids';
    if (/tec-oil/.test(h)) return 'tecoil';
    if (/reconstruct/.test(h)) return 'recon';
    if (/anti-breakage/.test(h)) return 'anti';
    if (/cachos|super-light|curl/.test(h) || tg.indexOf('curly / wavy / coily hair') > -1) return 'cachos';
    return 'treat';
  }
  function ehKit(p) {
    var h = String(p.h).toLowerCase();
    return tagSet(p).indexOf('hair gift set') > -1 || /-kit$|-kit-|-set$|-set-|shampoo-conditioner/.test(h);
  }
  /* Ordem dentro da prateleira: disponivel antes de esgotado; depois o passo
     da rotina (shampoo, condicionador, mascara, finalizacao); kit fecha. */
  var PESO = [['co-wash', 8], ['shampoo-conditioner', 85], ['shampoo', 10], ['conditioner', 20], ['mask', 30], ['acidifier', 35],
    ['leave-in', 50], ['activator', 55], ['jelly', 60], ['mousse', 64], ['cream', 66], ['spray', 68], ['day-after', 69], ['elixir', 70],
    ['kit', 90], ['set', 88]];
  function peso(p) {
    var s = String(p.h).toLowerCase();
    for (var i = 0; i < PESO.length; i++) { if (s.indexOf(PESO[i][0]) > -1) return PESO[i][1]; }
    return 75;
  }
  function ordena(a, b) {
    if (a.av !== b.av) return a.av ? -1 : 1;
    var pa = peso(a), pb = peso(b);
    if (pa !== pb) return pa - pb;
    return a.min.pr - b.min.pr;
  }
  function ordenaAba(a, b) {
    if (a.av !== b.av) return a.av ? -1 : 1;
    if (a.isKit !== b.isKit) return a.isKit ? 1 : -1;
    var fa = FAMILIAS.indexOf(a.fam), fb = FAMILIAS.indexOf(b.fam);
    if (fa !== fb) return fa - fb;
    return ordena(a, b);
  }

  var PRODUCTS = prepara(RAW);

  /* ---------- imagens com srcset -------------------------------------------- */
  function imgW(src, w) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(src) { return [300, 450, 600].map(function (w) { return imgW(src, w) + ' ' + w + 'w'; }).join(', '); }

  /* ---------- selo da Entrega Garantida --------------------------------------
     Abaixo de ~20px a arte oficial (que tem texto) vira borrao: no micro-selo
     do card entra o escudo em SVG. */
  var ESCUDO = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.6 4.6 5.4v6c0 4.4 3.1 8.5 7.4 9.9 4.3-1.4 7.4-5.5 7.4-9.9v-6L12 2.6Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M8.6 12.1l2.3 2.3 4.5-4.6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SELO = CFG.seloUrl ? '<img class="av-selo-img" src="' + esc(CFG.seloUrl) + '" alt="" width="120" height="126" loading="lazy">' : ESCUDO;

  /* ---------- titulo curto do card ---------------------------------------------
     No site oficial o nome no card e curto e em caixa alta ("KIT ACIDIFICANTE").
     O titulo da MKPBR e longo (tamanho, beneficios). No CARD mostramos o nome
     ate o primeiro separador; o titulo completo fica na ficha e no aria-label. */
  function curto(tt) {
    var s = String(tt || '').replace(/^\s*Arvensis\s+/i, '');
    var m = s.split(/\s[–—-]\s|\s\|\s|:\s|,\s|\s\(|（|、|،\s/)[0];
    return (m && m.length >= 8) ? m : s;
  }

  /* ---------- card ---------------------------------------------------------- */
  function desconto(p) {
    var v = p.min;
    if (!v.cmpf) return null;
    var de = parseMoney(v.cmpf), por = parseMoney(v.prf);
    if (!isFinite(de) || !isFinite(por) || de <= por) return null;
    return { pct: Math.round((1 - por / de) * 100), economia: de - por };
  }
  function precoHTML(p, v) {
    v = v || p.min;
    var corpo = (v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' : '') + '<b>' + esc(v.prf) + '</b>';
    return (p.faixa && v === p.min ? '<span class="av-card__from">' + esc(t('from')) + '</span>' : '') + corpo;
  }
  /* selos "Promocao" + "X% OFF", como no card oficial (so com desconto real) */
  function badgesHTML(p, v) {
    v = v || p.min;
    var d = desconto({ min: v });
    if (!d || d.pct < 5) return '';
    return '<span class="av-b av-b--promo">' + esc(t('promo')) + '</span><span class="av-b av-b--off">' + d.pct + '% ' + esc(t('off')) + '</span>';
  }
  /* Estrelas SO quando o produto tem nota cadastrada (metafield de reviews).
     Nada de nota inventada. */
  function starsHTML(p) {
    if (!p.rr || !p.rc) return '<div class="av-stars" aria-hidden="true"></div>';
    var cheias = Math.round(p.rr);
    return '<div class="av-stars" aria-label="' + esc(p.rr.toFixed(1) + ' / 5') + '"><i aria-hidden="true">' +
      '★★★★★'.slice(0, cheias) + '☆☆☆☆☆'.slice(0, 5 - cheias) + '</i>(' + fmtNum(p.rc) + ')</div>';
  }
  function cardHTML(p) {
    var img = p.img[0] || {};
    var rotulo = !p.av ? t('soldout') : (p.multi ? t('pdp_choose_card') : t('add'));
    var attr = p.multi ? ' data-av-open-handle="' + esc(p.h) + '"' : ' data-av-add="' + p.min.id + '"';
    return '' +
      '<div class="av-card__img">' +
        (img.s ? '<img src="' + esc(imgW(img.s, 450)) + '" srcset="' + esc(srcset(img.s)) + '" sizes="(max-width:700px) 46vw, 300px"' +
          ' alt="' + esc(img.a || p.t) + '" loading="lazy" decoding="async" width="600" height="600">' : '') +
        (p.isNew && p.av ? '<span class="av-card__new">' + esc(t('new_b')) + '</span>' : '') +
        (p.av ? '' : '<span class="av-card__flag">' + esc(t('soldout')) + '</span>') +
        '<span class="av-card__quick" aria-hidden="true">' + esc(t('quick')) + '</span>' +
      '</div>' +
      '<div class="av-card__badges">' + badgesHTML(p) + (function () { var e = ecoDoGrande(p.h); return e ? ecoBadge(e) : ''; })() + '</div>' +
      '<h3>' + esc(curto(p.t)) + '</h3>' +
      starsHTML(p) +
      '<div class="av-card__price">' + precoHTML(p) + '</div>' +
      /* micro-selo da Entrega Garantida: responde antes do clique */
      '<span class="av-card__del">' + ESCUDO + esc(t('del_card')) + '</span>' +
      '<button type="button" class="av-btn av-card__add"' + attr + (p.av ? '' : ' disabled') + '>' + esc(rotulo) + '</button>';
  }
  /* O card NAO pode ser um <button> (botao dentro de botao e HTML invalido):
     div com role=button, e o clique no botao de comprar e tratado ANTES. */
  function cardEl(p) {
    var el = D.createElement('div');
    el.className = 'av-card' + (p.av ? '' : ' av-card--out');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', p.t);
    el.dataset.avHandle = p.h;
    el.innerHTML = cardHTML(p);
    return el;
  }
  function porHandle(h) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].h === h) return PRODUCTS[i];
    return null;
  }
  function pinta(grid, lista) {
    if (!grid) return;
    grid.innerHTML = '';
    grid.setAttribute('aria-busy', 'false');
    lista.forEach(function (p) { grid.appendChild(cardEl(p)); });
  }

  /* ---------- prateleiras ------------------------------------------------------ */
  function renderGrids() {
    var vazio = !PRODUCTS.length;
    var painel = $('[data-av-nostock]');
    if (painel) painel.hidden = !vazio;
    if (vazio) {
      $$('.av-shelf,.av-rsec,#av-cats,.av-fams,#av-quiz,#av-routine').forEach(function (s) { s.hidden = true; });
      return;
    }

    var buckets = {};
    FAMILIAS.forEach(function (k) { buckets[k] = []; });
    PRODUCTS.forEach(function (p) { if (buckets[p.fam]) buckets[p.fam].push(p); });

    FAMILIAS.forEach(function (k) {
      var grid = $('[data-av-grid="' + k + '"]');
      var list = buckets[k].sort(ordena);
      var sec = $('[data-av-shelf="' + k + '"]');
      /* Linha vazia no mercado: some a prateleira E todo atalho que aponta
         para ela (um link que rola para uma secao escondida nao leva a nada). */
      var atalhos = $$('a[href="#av-fam-' + k + '"]').filter(function (a) { return !a.closest('.av-hero'); });
      var cartao = $('[data-av-famcard="' + k + '"]');
      if (!list.length) {
        if (sec) sec.hidden = true;
        atalhos.forEach(function (a) { (a.closest('li') || a).hidden = true; });
        if (cartao) cartao.hidden = true;
        return;
      }
      if (sec) sec.hidden = false;
      atalhos.forEach(function (a) { (a.closest('li') || a).hidden = false; });
      if (cartao) cartao.hidden = false;
      pinta(grid, list);
      $$('[data-av-count-fam="' + k + '"]').forEach(function (n) { n.textContent = fmtNum(list.length); });
      pintaCartaoFamilia(k, list);
      ligaRail(railDe(k));
    });

    /* prateleiras da home oficial */
    var disp = PRODUCTS.filter(function (p) { return p.av; });
    var ofertas = disp.filter(function (p) { var d = desconto(p); return d && d.pct >= 5; })
      .sort(function (a, b) { return desconto(b).pct - desconto(a).pct || ordena(a, b); }).slice(0, 12);
    var novos = disp.filter(function (p) { return p.isNew; }).sort(function (a, b) { return b.c < a.c ? -1 : (b.c > a.c ? 1 : ordena(a, b)); }).slice(0, 12);
    var best = (CFG.best || []).map(porHandle).filter(function (p) { return p && p.av; });
    var vizu = PRODUCTS.filter(function (p) { return p.fam === 'vizu'; }).sort(ordena);
    var kits = disp.filter(function (p) { return p.isKit; }).sort(function (a, b) { return FAMILIAS.indexOf(a.fam) - FAMILIAS.indexOf(b.fam) || ordena(a, b); });
    /* tamanho salao: os 1 L que custam menos por 100 ml que o 300 ml (#av-cfg eco) */
    var salao = [];
    ECO.forEach(function (par) { var e = ecoCalc(par); if (e && salao.indexOf(e.b) < 0) salao.push(e.b); });
    /* chaves com prefixo r- : "vizu" tambem e o nome de uma linha (prateleira) */
    [['r-offers', ofertas, 4], ['r-new', novos, 4], ['r-best', best, 4], ['r-vizu', vizu, 1], ['r-kits', kits, 3], ['r-salon', salao, 1]].forEach(function (x) {
      var sec = $('[data-av-rsec="' + x[0] + '"]');
      if (!sec) return;
      /* prateleira curta demais para o mercado atual nao aparece (ex.: sem
         preco "de" no mercado nao ha Ofertas) — e some tambem o item do menu
         que leva a ela, para nao virar link morto */
      var vazio = x[1].length < x[2];
      sec.hidden = vazio;
      $$('a[href="#' + sec.id + '"]').forEach(function (a) { (a.closest('li') || a).hidden = vazio; });
      if (vazio) return;
      pinta($('[data-av-grid="' + x[0] + '"]'), x[1]);
      ligaRail(railDe(x[0]));
    });

    montaPopulares();
    var np = $('[data-av-nprod]');
    if (np) np.textContent = fmtNum(PRODUCTS.length);
    vendasCatalogo();
  }

  /* Cartao da linha no topo: foto do primeiro produto avulso disponivel e
     "N · a partir de X" com o menor preco da linha. */
  function pintaCartaoFamilia(k, list) {
    var card = $('[data-av-famcard="' + k + '"]');
    if (!card) return;
    var capa = list.filter(function (p) { return p.av && !p.isKit && p.img[0]; })[0] || list.filter(function (p) { return p.img[0]; })[0];
    /* a foto vem PRONTA do servidor (v2): o JS so preenche se faltar — assim o
       circulo nao fica vazio enquanto o catalogo baixa, nem troca de foto depois */
    var img = $('[data-av-famimg]', card);
    if (img && capa && !img.getAttribute('src')) {
      img.dataset.h = capa.h;
      img.src = imgW(capa.img[0].s, 240);
    }
    var disp = list.filter(function (p) { return p.av; });
    var menor = (disp.length ? disp : list).slice().sort(function (a, b) { return a.min.pr - b.min.pr; })[0];
    var from = $('[data-av-famfrom]', card);
    if (from) from.textContent = fmtNum(list.length) + ' · ' + t('from') + ' ' + menor.min.prf;
  }

  /* ==========================================================================
     CARROSSEL DE UMA LINHA — scroll NATIVO; as setas so empurram o scroll.
     ========================================================================== */
  function railDe(k) { return $('[data-av-rail="' + k + '"]'); }
  function atualizaSetas(rail) {
    if (!rail) return;
    var track = $('.av-rail__track', rail);
    var prev = $('[data-av-rail-prev]', rail);
    var next = $('[data-av-rail-next]', rail);
    if (!track || !prev || !next) return;
    if (rail.classList.contains('av-rail--grid')) { prev.hidden = true; next.hidden = true; return; }
    var max = track.scrollWidth - track.clientWidth;
    var x = Math.abs(track.scrollLeft); /* em RTL o Chrome devolve scrollLeft negativo */
    var sobra = max > 4;
    prev.hidden = !sobra || x < 8;
    next.hidden = !sobra || x > max - 8;
  }
  function ligaRail(rail) {
    if (!rail) return;
    var track = $('.av-rail__track', rail);
    if (!track) return;
    if (!rail.dataset.pronto) {
      rail.dataset.pronto = '1';
      track.addEventListener('scroll', function () { atualizaSetas(rail); }, { passive: true });
      track.addEventListener('load', function () { atualizaSetas(rail); }, true);
      $$('[data-av-rail-prev],[data-av-rail-next]', rail).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var dir = b.hasAttribute('data-av-rail-next') ? 1 : -1;
          if (D.documentElement.dir === 'rtl') dir = -dir;
          track.scrollBy({ left: dir * Math.max(260, track.clientWidth * 0.8), behavior: 'smooth' });
        });
      });
    }
    atualizaSetas(rail);
    if (window.requestAnimationFrame) requestAnimationFrame(function () { atualizaSetas(rail); });
    setTimeout(function () { atualizaSetas(rail); }, 500);
  }
  function ligaVerTodos() {
    $$('[data-av-toggle]').forEach(function (b) {
      if (b.dataset.pronto) return;
      b.dataset.pronto = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var rail = railDe(b.dataset.avToggle);
        if (!rail) return;
        var grade = rail.classList.toggle('av-rail--grid');
        var rot = $('span', b);
        if (rot) rot.textContent = grade ? t('see_less') : t('see_all');
        b.setAttribute('aria-expanded', String(grade));
        atualizaSetas(rail);
      });
    });
  }

  /* ---------- cabecalho: altura real e modo compacto ------------------------------
     A barra de linhas fixa e o scroll-margin usam a altura REAL do cabecalho
     (muda com a largura e com o idioma). No celular a busca em pilula some ao
     rolar para baixo e volta ao subir: o cabecalho nao come a tela. */
  var head;
  function medeCabecalho() {
    if (!head) return;
    D.body.style.setProperty('--av-hh', Math.round(head.getBoundingClientRect().height) + 'px');
  }
  function ligaCabecalho() {
    head = $('[data-av-head]');
    if (!head) return;
    medeCabecalho();
    if (window.ResizeObserver) new ResizeObserver(medeCabecalho).observe(head);
    var ultimo = window.scrollY, pedido = false;
    window.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(function () {
        pedido = false;
        var y = window.scrollY;
        if (window.innerWidth <= 900) {
          if (y > 240 && y > ultimo + 4) head.classList.add('is-min');
          else if (y < ultimo - 4 || y < 120) head.classList.remove('is-min');
        } else head.classList.remove('is-min');
        ultimo = y;
      });
    }, { passive: true });
  }

  /* Barra de linhas FIXA: acesa so enquanto a pessoa esta DENTRO das
     prateleiras (#av-lines). Medida direta a cada rolagem (o
     IntersectionObserver perde saltos de ancora — medido na Prohall). */
  function ligaBarraFamilias() {
    var barra = $('[data-av-fams]');
    var ref = $('#av-lines');
    if (!barra || !ref || !PRODUCTS.length || barra.dataset.pronto) return;
    barra.dataset.pronto = '1';
    var chips = $$('.av-fam', barra);
    var pedido = false;
    function mede() {
      pedido = false;
      var r = ref.getBoundingClientRect();
      var hh = head ? head.getBoundingClientRect().height : 0;
      var dentro = r.top < hh + 40 && r.bottom > hh + 160;
      barra.classList.toggle('is-on', dentro);
      var atual = null;
      FAMILIAS.forEach(function (k) {
        var s = D.getElementById('av-fam-' + k);
        if (s && !s.hidden && s.getBoundingClientRect().top < hh + 200) atual = k;
      });
      chips.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('href') === '#av-fam-' + atual); });
    }
    function agenda() {
      if (pedido) return;
      pedido = true;
      if (window.requestAnimationFrame) requestAnimationFrame(mede); else setTimeout(mede, 60);
    }
    window.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', agenda);
    mede();
  }

  /* ==========================================================================
     BUSCA — inteira no navegador, sobre o JSON ja baixado (nada de /search,
     que traria outras marcas para dentro da loja da Arvensis).
     ========================================================================== */
  var buscaEl, buscaVeil, buscaInput, buscaRes, buscaSug, buscaNone, buscaT;
  function normal(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* motor antigo */ }
    return s;
  }
  function buscar(q) {
    var n = normal(q).trim();
    if (n.length < 2) return [];
    var termos = n.split(/\s+/);
    return PRODUCTS.filter(function (p) {
      /* o handle entra na busca: e em ingles e nao muda com o idioma */
      var alvo = normal(p.t) + ' ' + normal(p.h.replace(/-/g, ' ')) + ' ' + normal(p.tags.join(' ')) + ' ' +
                 normal(p.v.map(function (v) { return v.sku || ''; }).join(' '));
      return termos.every(function (x) { return alvo.indexOf(x) > -1; });
    }).sort(ordenaAba).slice(0, 40);
  }
  function sresHTML(p) {
    var img = (p.img[0] || {}).s || '';
    return '<button type="button" class="av-sres" data-av-open-handle="' + esc(p.h) + '">' +
      '<span class="av-sres__img">' + (img ? '<img src="' + esc(imgW(img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span><b>' + esc(curto(p.t)) + '</b><span>' + precoHTML(p).replace(/<\/?b>/g, '') + '</span></span></button>';
  }
  /* "Por onde comecar": os mais vendidos no Brasil que existem no mercado */
  function montaPopulares() {
    var alvo = $('[data-av-search-popular]');
    if (!alvo) return;
    var lista = (CFG.best || []).map(porHandle).filter(function (p) { return p && p.av; }).slice(0, 5);
    alvo.innerHTML = lista.map(sresHTML).join('');
  }
  function pintaResultados(q) {
    if (!buscaRes) return;
    var lista = buscar(q);
    var temTermo = normal(q).trim().length >= 2;
    if (buscaSug) buscaSug.hidden = temTermo;
    buscaRes.hidden = !temTermo;
    if (buscaNone) buscaNone.hidden = !(temTermo && !lista.length);
    buscaRes.innerHTML = lista.map(sresHTML).join('');
  }
  function abrirBusca(termo) {
    if (!buscaEl) return;
    fecharMenu();
    if (termo != null && buscaInput) { buscaInput.value = termo; pintaResultados(termo); }
    if (buscaEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    buscaEl.classList.add('is-on');
    buscaEl.setAttribute('aria-hidden', 'false');
    if (buscaVeil) { buscaVeil.hidden = false; requestAnimationFrame(function () { buscaVeil.classList.add('is-on'); }); }
    travarRolagem();
    if (buscaInput) setTimeout(function () { buscaInput.focus(); }, 60);
  }
  function fecharBusca() {
    if (!buscaEl || !buscaEl.classList.contains('is-on')) return;
    buscaEl.classList.remove('is-on');
    buscaEl.setAttribute('aria-hidden', 'true');
    if (buscaVeil) { buscaVeil.classList.remove('is-on'); setTimeout(function () { buscaVeil.hidden = true; }, 220); }
    destravarRolagem();
  }
  function ligaBusca() {
    buscaEl = $('[data-av-search]');
    buscaVeil = $('[data-av-search-veil]');
    buscaInput = $('[data-av-search-input]');
    buscaRes = $('[data-av-search-results]');
    buscaSug = $('[data-av-search-suggest]');
    buscaNone = $('[data-av-search-none]');
    if (!buscaEl || !buscaInput) return;
    buscaInput.addEventListener('input', function () {
      clearTimeout(buscaT);
      var v = buscaInput.value;
      buscaT = setTimeout(function () { pintaResultados(v); }, 120);
    });
    buscaInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(buscaT); pintaResultados(buscaInput.value); }
    });
  }

  /* ---------- menu do celular ------------------------------------------------------- */
  var menuEl, menuVeil;
  function abrirMenu() {
    if (!menuEl || menuEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    menuEl.classList.add('is-on');
    menuEl.setAttribute('aria-hidden', 'false');
    if (menuVeil) { menuVeil.hidden = false; requestAnimationFrame(function () { menuVeil.classList.add('is-on'); }); }
    travarRolagem();
    var x = $('[data-av-menu-close]', menuEl);
    if (x) x.focus();
  }
  function fecharMenu() {
    if (!menuEl || !menuEl.classList.contains('is-on')) return;
    menuEl.classList.remove('is-on');
    menuEl.setAttribute('aria-hidden', 'true');
    if (menuVeil) { menuVeil.classList.remove('is-on'); setTimeout(function () { menuVeil.hidden = true; }, 220); }
    destravarRolagem();
  }

  /* ---------- paginas 2..N ----------------------------------------------------------
     Pelo ?view=arvensis-professional-data, que devolve SO o JSON. Tres
     tentativas com pausa crescente: um 502 do proprio Shopify ja tirou metade
     da vitrine da Prohall sem aviso nenhum. */
  function buscaPagina(n, tentativa) {
    var url = (CFG.root || '') + '/pages/arvensis-professional?view=arvensis-professional-data&page=' + n;
    /* SEM "Accept: application/json": com esse cabecalho a Shopify ignora o
       ?view= e devolve o JSON nativo da pagina (medido na Gold Spell). */
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        var j = JSON.parse(txt);
        if (!j || !j.products || !j.products.length) throw new Error('pagina vazia');
        return j.products;
      })
      .catch(function (err) {
        if (tentativa >= 3) { console.warn('[arvensis] pagina ' + n + ' nao veio:', err.message); return []; }
        return new Promise(function (ok) { setTimeout(ok, 400 * tentativa); }).then(function () { return buscaPagina(n, tentativa + 1); });
      });
  }
  function carregarResto() {
    var total = Number(CFG.pages) || 1;
    if (total < 2 || !PRODUCTS.length) return Promise.resolve();
    var pedidos = [];
    for (var n = 2; n <= total; n++) pedidos.push(buscaPagina(n, 1));
    return Promise.all(pedidos).then(function (partes) {
      var vistos = {};
      PRODUCTS.forEach(function (p) { vistos[p.h] = true; });
      var novos = [];
      partes.forEach(function (lista) { lista.forEach(function (p) { if (p && p.h && !vistos[p.h]) { vistos[p.h] = true; novos.push(p); } }); });
      if (!novos.length) return;
      PRODUCTS = PRODUCTS.concat(prepara(novos));
      renderGrids();
    });
  }

  /* ---------- trava de rolagem ---------------------------------------------------------
     Trava o HTML e o body: com html{overflow-x:clip}, travar so o body deixava
     a roda do mouse rolar a LP por tras do popup (armadilha da Peach Up). */
  var travas = 0;
  function travarRolagem() { travas++; D.documentElement.classList.add('av-lock'); D.body.classList.add('av-lock'); }
  function destravarRolagem() {
    travas = Math.max(0, travas - 1);
    if (!travas) { D.documentElement.classList.remove('av-lock'); D.body.classList.remove('av-lock'); }
  }

  /* ---------- ficha do produto ---------------------------------------------------------- */
  var pdpOvl, pdpBox, lastFocus = null;
  var PDP = { p: null, v: null };
  var INFO = {};

  function linhas(txt) { return String(txt || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean); }
  function bulletsHTML(txt) {
    var ls = linhas(txt);
    if (!ls.length) return '';
    return ls.length > 1 ? '<ul>' + ls.map(function (l) { return '<li>' + esc(l.replace(/^[-•]\s*/, '')) + '</li>'; }).join('') + '</ul>' : '<p>' + esc(ls[0]) + '</p>';
  }
  function parasHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n{2,}|\n---\n/).map(function (b) {
      var l = b.trim();
      return l ? '<p>' + esc(l).replace(/\n/g, '<br>') + '</p>' : '';
    }).join('');
  }
  /* "Ingredientes explicados": blocos separados por ---, NOME na primeira
     linha; linha comecando com ⚠ e aviso e ganha destaque proprio. */
  function ingHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n?---\n?/).map(function (bloco) {
      var ls = linhas(bloco);
      if (!ls.length) return '';
      var nome = ls.shift();
      var aviso = ls.filter(function (x) { return /^⚠/.test(x); });
      var corpo = ls.filter(function (x) { return !/^⚠/.test(x); });
      return '<div class="av-ing"><strong>' + esc(nome) + '</strong>' + esc(corpo.join(' ')) +
        (aviso.length ? '<span class="av-warn">' + esc(aviso.join(' ')) + '</span>' : '') + '</div>';
    }).join('');
  }
  function acc(key, body, open) {
    if (!body) return '';
    return '<details class="av-acc"' + (open ? ' open' : '') + '><summary>' + esc(t(key)) + '</summary><div class="av-acc__c">' + body + '</div></details>';
  }
  function qdHTML() {
    var passos = CFG.steps || [];
    if (!passos.length) return '';
    return '<div class="av-pdp__qd" data-av-pdp-qd><strong>' + esc(t('qd_t')) + '</strong><ul>' +
      passos.map(function (s) {
        return '<li data-q="' + s.q + '"><b>' + s.p + '%</b><span>' + esc(s.q >= 4 ? t('qd_4') : t('qd_' + s.q)) + '</span></li>';
      }).join('') + '</ul><small>' + esc(t('qd_d')) + ' ' + esc(t('qd_note')) + '</small></div>';
  }
  function optHTML(p) {
    if (!p.multi) return '';
    var rotulo = p.opt && p.opt !== 'Title' ? p.opt : t('pdp_opt');
    return '<div class="av-opt"><span class="av-opt__l" id="av-opt-l">' + esc(rotulo) + '</span>' +
      '<div class="av-opt__list" role="group" aria-labelledby="av-opt-l">' +
      p.v.map(function (v) {
        var ec = economiaVar(p, v), un = ec ? unidadeVar(p, v) : null;
        return '<button type="button" class="av-opt__b" data-av-var="' + v.id + '" aria-pressed="' + (PDP.v && PDP.v.id === v.id) + '"' +
          (v.av ? '' : ' disabled') + '>' + esc(v.t) + (ec ? '<small class="av-opt__eco">' + esc(tf('eco_badge', { pct: ec, u: un.u })) + '</small>' : '') + '</button>';
      }).join('') + '</div></div>';
  }
  function pintarVariante() {
    var p = PDP.p, v = PDP.v;
    if (!p || !v) return;
    var preco = $('[data-av-pdp-price]');
    if (preco) preco.innerHTML = (v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' : '') + '<b>' + esc(v.prf) + '</b>';
    var bdg = $('[data-av-pdp-badges]');
    if (bdg) bdg.innerHTML = badgesHTML(p, v);
    var sku = $('[data-av-pdp-sku]');
    if (sku) { sku.textContent = t('pdp_sku') + ': ' + (v.sku || '—'); sku.hidden = !v.sku; }
    $$('[data-av-var]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.avVar) === Number(v.id))); });
    $$('[data-av-add],[data-av-buy]', pdpBox).forEach(function (b) {
      var ehAdd = b.hasAttribute('data-av-add');
      if (ehAdd) b.dataset.avAdd = v.id; else b.dataset.avBuy = v.id;
      b.disabled = !v.av;
      b.textContent = v.av ? (ehAdd ? t('add') : t('buy')) : t('soldout');
    });
    var qty = $('.av-pdp__qty');
    if (qty) qty.hidden = !v.av;
    pintaEconomiaPDP(p, v);
    marcarDegrausPDP();
  }
  /* preco por 100 ml/g (variantes de tamanho e pares do tamanho salao) e,
     no produto de 300 ml, a caixa que leva ao 1 L */
  function pintaEconomiaPDP(p, v) {
    var un = $('[data-av-pdp-unit]'), box = $('[data-av-pdp-eco]');
    var peq = ecoDoPequeno(p.h, v.id), gr = ecoDoGrande(p.h), uv = unidadeVar(p, v);
    if (un) {
      var txt = '';
      if (gr && (!gr.par.bvid || Number(gr.par.bvid) === Number(v.id))) txt = esc(tf('eco_unit', { price: money(Math.round(gr.ub)), u: gr.u })) + ' ' + ecoBadge(gr);
      else if (peq) txt = esc(tf('eco_unit', { price: money(Math.round(peq.us)), u: peq.u }));
      else if (uv) txt = esc(tf('eco_unit', { price: money(Math.round(uv.por100)), u: uv.u }));
      un.innerHTML = txt;
      un.hidden = !txt;
    }
    if (box) {
      box.hidden = !peq;
      if (peq) box.innerHTML = '<p>' + esc(tf('eco_pdp', { pct: peq.pct })) + '</p>' +
        '<button type="button" class="av-btn av-btn--sm av-btn--ghost" data-av-open-handle="' + esc(peq.b.h) + '">' + esc(t('eco_see')) + '</button>';
    }
  }

  var PDP_QTD_MAX = 10;
  function qtdHTML() {
    return '<div class="av-pdp__qty"><span class="av-pdp__qty-l" id="av-pdp-qty-l">' + esc(t('pdp_qty')) + '</span>' +
      '<span class="av-step av-step--lg" role="group" aria-labelledby="av-pdp-qty-l">' +
      '<button type="button" data-av-pdp-step="-1" aria-label="' + esc(t('c_less')) + '" disabled>&minus;</button>' +
      '<span data-av-pdp-qtd aria-live="polite">1</span>' +
      '<button type="button" data-av-pdp-step="1" aria-label="' + esc(t('c_more')) + '">+</button></span></div>';
  }
  function pdpQtd() {
    var el = $('[data-av-pdp-qtd]');
    var n = el ? parseInt(el.textContent, 10) : 1;
    return (isFinite(n) && n > 0) ? Math.min(PDP_QTD_MAX, n) : 1;
  }
  function porQtdPDP(n) {
    var el = $('[data-av-pdp-qtd]');
    if (!el) return;
    n = Math.min(PDP_QTD_MAX, Math.max(1, n));
    el.textContent = String(n);
    var menos = $('[data-av-pdp-step="-1"]'), mais = $('[data-av-pdp-step="1"]');
    if (menos) menos.disabled = n <= 1;
    if (mais) mais.disabled = n >= PDP_QTD_MAX;
    marcarDegrausPDP();
    crAtualiza();
  }
  /* O Pumper conta o carrinho INTEIRO: acende o degrau do que o carrinho VAI
     ter depois de somar a quantidade escolhida aqui. */
  function marcarDegrausPDP() {
    var caixa = $('[data-av-pdp-qd]');
    if (!caixa) return;
    var total = CART.count + pdpQtd();
    var atingido = null;
    (CFG.steps || []).forEach(function (s) { if (total >= s.q) atingido = s; });
    $$('li', caixa).forEach(function (li) { li.classList.toggle('is-on', !!atingido && Number(li.dataset.q) === atingido.q); });
  }
  /* O que abre o popup da garantia, de qualquer lugar: <label for>, nunca um
     link para outra guia (quem sai da LP perde o carrinho de vista). */
  function abreGarantia(rotulo) {
    return '<label class="av-lnk" for="av-guar-cbx" role="button" tabindex="0">' + esc(t(rotulo)) + '</label>';
  }
  function entregaHTML() {
    return '<div class="av-pdp__del">' + SELO + '<div><b>' + esc(t('del_t')) + '</b><p>' + esc(t('del_pdp')) + '</p>' + abreGarantia('del_c') + '</div></div>';
  }
  /* A parte pesada da ficha: descricao completa + resumo por IA, pelo
     ?view=arvensis-professional-info. Se falhar, cai para o /products/<h>.js. */
  function carregaInfo(h) {
    if (INFO[h]) return Promise.resolve(INFO[h]);
    var base = (CFG.root || '') + '/products/' + encodeURIComponent(h);
    return fetch(base + '?view=arvensis-professional-info', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) { return JSON.parse(txt); })
      .catch(function () {
        return fetch(base + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) { return { ai: {}, d: j.description || '' }; });
      })
      .then(function (info) { INFO[h] = info || { ai: {}, d: '' }; return INFO[h]; })
      .catch(function () { return { ai: {}, d: '' }; });
  }
  function pintaInfo(p, info) {
    var alvo = $('[data-av-pdp-more]');
    if (!alvo || !PDP.p || PDP.p.h !== p.h) return;
    var ai = info.ai || {};
    var tag = $('[data-av-pdp-tag]');
    if (tag) { tag.textContent = ai.tag || ''; tag.hidden = !ai.tag; }
    alvo.innerHTML =
      acc('pdp_purpose', bulletsHTML(ai.pur), true) +
      acc('pdp_high', bulletsHTML(ai.hig)) +
      acc('pdp_how', parasHTML(ai.how)) +
      acc('pdp_audience', parasHTML(ai.aud)) +
      acc('pdp_good', bulletsHTML(ai.gtk)) +
      acc('pdp_ing', ingHTML(ai.ing)) +
      acc('pdp_tog', parasHTML(ai.tog)) +
      (info.d ? '<details class="av-acc"' + (ai.pur ? '' : ' open') + '><summary>' + esc(t('pdp_desc')) + '</summary><div class="av-acc__c av-desc">' + info.d + '</div></details>' : '') +
      (info.note ? '<p class="av-legal">' + esc(info.note) + '</p>' : '');
  }
  function openPDP(handle) {
    var p = porHandle(handle);
    if (!p || !pdpOvl) return false;
    fecharMenu();
    if (!pdpOvl.classList.contains('is-on')) lastFocus = D.activeElement;
    PDP.p = p;
    PDP.v = p.min; /* abre na variante disponivel mais barata, nunca numa esgotada */
    var thumbs = p.img.map(function (im, i) {
      return '<button type="button" data-av-th="' + i + '"' + (i === 0 ? ' aria-current="true"' : '') + ' aria-label="' + (i + 1) + '/' + p.img.length + '">' +
        '<img src="' + esc(imgW(im.s, 120)) + '" alt="" loading="lazy"></button>';
    }).join('');
    var im0 = p.img[0] || {};
    pdpBox.innerHTML =
      '<button type="button" class="av-x" data-av-pdp-close aria-label="' + esc(t('pdp_close')) + '">&times;</button>' +
      '<div class="av-pdp">' +
        '<div class="av-pdp__gal">' +
          '<div class="av-pdp__main">' + (im0.s ? '<img src="' + esc(imgW(im0.s, 900)) + '" alt="' + esc(im0.a || p.t) + '" width="900" height="900" data-av-main>' : '') + '</div>' +
          (p.img.length > 1 ? '<div class="av-pdp__thumbs">' + thumbs + '</div>' : '') +
        '</div>' +
        '<div class="av-pdp__info">' +
          '<p class="av-pdp__brand">Arvensis Professional · ' + esc(t('official')) + '</p>' +
          '<h2 id="av-pdp-t">' + esc(p.t) + '</h2>' +
          starsHTML(p) +
          '<p class="av-pdp__tag" data-av-pdp-tag hidden></p>' +
          '<div class="av-pdp__badges" data-av-pdp-badges></div>' +
          '<div class="av-pdp__price" data-av-pdp-price></div>' +
          '<p class="av-pdp__unit" data-av-pdp-unit hidden></p>' +
          optHTML(p) + qtdHTML() + qdHTML() +
          '<div class="av-pdp__acts">' +
            '<button type="button" class="av-btn av-btn--ghost" data-av-add=""></button>' +
            '<button type="button" class="av-btn" data-av-buy=""></button>' +
          '</div>' +
          '<div class="av-eco" data-av-pdp-eco hidden></div>' +
          crHTML(p) +
          entregaHTML() +
          '<div data-av-pdp-more><div class="av-skel" aria-hidden="true"><i></i><i></i><i></i></div></div>' +
          '<p class="av-nota" style="margin:0" data-av-pdp-sku></p>' +
        '</div>' +
      '</div>';
    if (!pdpOvl.classList.contains('is-on')) { pdpOvl.classList.add('is-on'); travarRolagem(); }
    pdpOvl.scrollTop = 0; pdpBox.scrollTop = 0;
    porQtdPDP(1);
    pintarVariante();
    crAtualiza();
    var x = $('[data-av-pdp-close]', pdpBox);
    if (x) x.focus();
    carregaInfo(p.h).then(function (info) { pintaInfo(p, info); });
    return true;
  }
  function closePDP() {
    if (!pdpOvl || !pdpOvl.classList.contains('is-on')) return;
    pdpOvl.classList.remove('is-on');
    destravarRolagem();
    pdpBox.innerHTML = '';
    PDP.p = null; PDP.v = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- carrinho ------------------------------------------------------------------- */
  var CART = { items: [], total: 0, count: Number((CFG.cart || {}).count) || 0, raw: null };
  var cartEl, veilEl, bodyEl, footEl, totalEl, countEl, qdEl, shipEl;

  /* Recado de frete CALCULADO por window.MKPBR_SHIP (a mesma conta da barra
     da loja) e escrito dentro do carrinho. */
  function espelharFrete() {
    if (!shipEl) return;
    var S = window.MKPBR_SHIP;
    if (!S || typeof S.compute !== 'function' || !CART.raw || CART.count < 1) { shipEl.hidden = true; return; }
    var e;
    try { e = S.compute(CART.raw); } catch (err) { console.error('[arvensis] frete', err); shipEl.hidden = true; return; }
    if (!e) { shipEl.hidden = true; return; }
    if (e.freeReached) shipEl.innerHTML = '<b>' + esc(t('ship_free')) + '</b>';
    else if (e.faltaProximo > 0 && e.economiaProximo > 0) {
      shipEl.innerHTML = '<b>' + esc(t('ship_more').replace('{v}', money(Math.round(e.faltaProximo * 100))).replace('{p}', money(Math.round(e.economiaProximo * 100)))) + '</b>';
    } else { shipEl.hidden = true; return; }
    shipEl.hidden = false;
  }
  function cartURL(path) { return (CFG.root || '') + path; }
  function aplicarCarrinho(c) {
    if (!c) return;
    CART.items = c.items || [];
    CART.total = c.total_price || 0;
    CART.count = c.item_count || 0;
    CART.raw = c;
    if (c.currency) CURRENCY = c.currency;
    syncCart();
  }
  function fetchCart() {
    return fetch(cartURL('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { aplicarCarrinho(c); return c; })
      .catch(function (e) { console.error('[arvensis] cart.js', e); });
  }
  function syncCart() {
    if (countEl) countEl.textContent = CART.count;
    /* a barra de frete da loja so aparece DEPOIS que existe carrinho */
    D.body.classList.toggle('av-has-cart', CART.count > 0);
    renderCart();
    markStep();
    vendasCarrinho();
  }
  function renderCart() {
    if (!bodyEl) return;
    if (!CART.items.length) {
      bodyEl.innerHTML = '<div class="av-cart__empty"><strong>' + esc(t('c_empty')) + '</strong><span>' + esc(t('c_empty_d')) + '</span>' +
        '<button type="button" class="av-btn av-btn--ghost av-btn--sm" data-av-cart-close>' + esc(t('c_empty_cta')) + '</button></div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    bodyEl.innerHTML = CART.items.map(function (it) {
      var img = it.image ? imgW(it.image, 160) : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="av-line__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="av-line" data-key="' + esc(it.key) + '">' +
        '<div class="av-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><span class="av-line__t">' + esc(curto(it.product_title || it.title)) + '</span>' + vt +
          '<div class="av-line__r"><span class="av-step">' +
            '<button type="button" data-av-qty="-1" aria-label="' + esc(t('c_less')) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-av-qty="1" aria-label="' + esc(t('c_more')) + '">+</button></span>' +
            '<span class="av-line__p">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</span></div>' +
          '<button type="button" class="av-line__x" data-av-rm>' + esc(t('c_rm')) + '</button>' +
          (function () {
            var e = ecoDoPequeno(it.handle, it.variant_id);
            return e ? '<button type="button" class="av-line__eco" data-av-swap="' + esc(it.key) + '" data-to="' + e.bv.id + '" data-q="' + it.quantity + '">' +
              esc(t('eco_swap')) + ' ' + ecoBadge(e) + '</button>' : '';
          })() +
        '</div></div>';
    }).join('') + cartCRHTML();
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = money(CART.total);
  }
  function markStep() {
    var atingido = null;
    (CFG.steps || []).forEach(function (s) { if (CART.count >= s.q) atingido = s; });
    $$('[data-av-qd] .av-qd__step').forEach(function (el) {
      el.classList.toggle('av-qd__step--on', !!atingido && Number(el.dataset.q) === atingido.q);
    });
    marcarDegrausPDP();
    if (qdEl) {
      if (atingido) {
        qdEl.textContent = (atingido.q >= 4 ? t('qd_4') : t('qd_' + atingido.q)) + ' · ' + atingido.p + '% ' + t('off') + ' — ' + t('qd_note');
        qdEl.hidden = false;
      } else qdEl.hidden = true;
    }
    espelharFrete();
  }
  function openCart() {
    if (!cartEl || cartEl.classList.contains('is-on')) return;
    fecharMenu();
    lastFocus = D.activeElement;
    cartEl.classList.add('is-on');
    cartEl.setAttribute('aria-hidden', 'false');
    if (veilEl) { veilEl.hidden = false; requestAnimationFrame(function () { veilEl.classList.add('is-on'); }); }
    travarRolagem();
    espelharFrete();
    var c = $('[data-av-cart-close]', cartEl);
    if (c) c.focus();
  }
  function closeCart() {
    if (!cartEl || !cartEl.classList.contains('is-on')) return;
    cartEl.classList.remove('is-on');
    cartEl.setAttribute('aria-hidden', 'true');
    if (veilEl) { veilEl.classList.remove('is-on'); setTimeout(function () { veilEl.hidden = true; }, 220); }
    destravarRolagem();
    if (lastFocus && lastFocus.focus && !pdpOvl.classList.contains('is-on')) lastFocus.focus();
  }

  var toastT;
  function toast(msg) {
    var el = $('[data-av-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }
  function addToCart(vid, abrir, btn, qtd) {
    if (!vid) return;
    var q = Math.min(PDP_QTD_MAX, Math.max(1, Number(qtd) || 1));
    var rotulo = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = t('added'); setTimeout(function () { btn.textContent = rotulo; }, 1400); }
        porQtdPDP(1);
        /* card e "adicionar" NAO abrem o carrinho; "comprar agora" abre */
        if (abrir) { closePDP(); openCart(); } else toast(t('toast_added'));
      })
      .catch(function (e) {
        console.error('[arvensis] add', e);
        if (btn) { btn.disabled = false; btn.textContent = rotulo; }
        toast(t('err_add'));
      });
  }
  function changeQty(key, qty) {
    return fetch(cartURL('/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(aplicarCarrinho)
      .catch(function (e) { console.error('[arvensis] change', e); });
  }

  /* ==========================================================================
     v2 (22/09/2026) — RECURSOS DE VENDA
     Foco: conversao, mais itens por pedido e ticket medio. Tudo le o catalogo
     do MERCADO (PRODUCTS): produto que nao existe ou esgotou nao entra.
       - carrossel do topo (3 artes em alta)
       - "Qual e o seu cabelo?" (quiz de 3 perguntas -> rotina pronta)
       - "Monte sua rotina" (4 passos, troca de produto, tamanho salao)
       - "Complete a rotina" (na ficha e no carrinho)
       - "Tamanho salao 1 L" (selo de economia, caixa na ficha, troca no carrinho)
     O desconto mostrado aqui e ESTIMATIVA: quem aplica e o Pumper no
     checkout, contando o TOTAL de itens do carrinho (kit conta 1).
     ========================================================================== */

  /* texto com marcadores: tf('rb_missing', {q: 3, pct: 10}) */
  function tf(k, o) {
    var s = t(k);
    Object.keys(o || {}).forEach(function (x) { s = s.split('{' + x + '}').join(String(o[x])); });
    return s;
  }
  function varPorId(p, id) {
    if (!p) return null;
    for (var i = 0; i < p.v.length; i++) if (Number(p.v[i].id) === Number(id)) return p.v[i];
    return null;
  }
  /* degrau atingido com n itens no carrinho (0 = nenhum) */
  function pctDe(n) {
    var pct = 0;
    (CFG.steps || []).forEach(function (s) { if (n >= s.q) pct = s.p; });
    return pct;
  }
  function proximoDegrau(n) {
    var st = (CFG.steps || []).filter(function (s) { return s.q > n; })[0];
    return st || null;
  }
  function degrausHTML(n) {
    var pct = pctDe(n);
    return '<ul class="av-tiers" aria-hidden="true">' + (CFG.steps || []).map(function (s) {
      return '<li class="' + (s.p === pct ? 'is-on' : (n >= s.q ? 'is-past' : '')) + '"><b>' + s.p + '%</b><span>' +
        esc(s.q >= 4 ? t('qd_4') : t('qd_' + s.q)) + '</span></li>';
    }).join('') + '</ul>';
  }
  function kitPuro(p) { return /(^|-)kit(-|$)/.test(String(p.h)); }

  /* ---------- tamanho e preco por 100 ml / 100 g ---------------------------------
     So em VARIANTES de tamanho (mascaras 300 g x 500 g) e nos pares do
     tamanho salao (#av-cfg eco). Titulo de kit nao entra: "300ml Each" daria
     preco por 100 ml errado. */
  function volDe(txt) {
    var s = String(txt || '');
    var m = /(\d+(?:[.,]\d+)?)\s*(ml|g)\b/i.exec(s);
    if (m) return { n: parseFloat(m[1].replace(',', '.')), u: m[2].toLowerCase() };
    m = /(\d+(?:[.,]\d+)?)\s*(l|liter|litre|litro)s?\b/i.exec(s);
    if (m) return { n: parseFloat(m[1].replace(',', '.')) * 1000, u: 'ml' };
    return null;
  }
  function unidadeVar(p, v) {
    if (!p.multi) return null;
    var a = volDe(v.t);
    if (!a || !a.n) return null;
    return { por100: v.pr / a.n * 100, u: a.u };
  }
  /* variantes de tamanho: % a menos por 100 g/ml contra a MENOR (so >= 5%) */
  function economiaVar(p, v) {
    var uv = unidadeVar(p, v);
    if (!uv) return 0;
    var base = null;
    p.v.forEach(function (x) {
      var ux = unidadeVar(p, x), vx = volDe(x.t);
      if (ux && ux.u === uv.u && (!base || vx.n < base.n)) base = { n: vx.n, por100: ux.por100 };
    });
    if (!base || base.por100 <= uv.por100) return 0;
    var pct = Math.round((1 - uv.por100 / base.por100) * 100);
    return pct >= 5 ? pct : 0;
  }
  var ECO = CFG.eco || [];
  function ecoCalc(par) {
    var s = porHandle(par.s), b = porHandle(par.b);
    if (!s || !b || !b.av) return null;
    var sv = par.svid ? varPorId(s, par.svid) : s.min;
    var bv = par.bvid ? varPorId(b, par.bvid) : b.min;
    if (!sv || !bv || !bv.av) return null;
    var us = sv.pr / par.sv * 100, ub = bv.pr / par.bv * 100;
    var pct = Math.round((1 - ub / us) * 100);
    if (pct < 10) return null;
    return { par: par, s: s, b: b, sv: sv, bv: bv, pct: pct, us: us, ub: ub, u: par.u || 'ml' };
  }
  /* par em que o produto (e a variante, quando o par pede uma) e o PEQUENO */
  function ecoDoPequeno(h, vid) {
    for (var i = 0; i < ECO.length; i++) {
      var par = ECO[i];
      if (par.s !== h) continue;
      if (par.svid && vid && Number(par.svid) !== Number(vid)) continue;
      var e = ecoCalc(par);
      if (e) return e;
    }
    return null;
  }
  /* maior economia em que o produto e o GRANDE (selo do card) */
  function ecoDoGrande(h) {
    var melhor = null;
    ECO.forEach(function (par) {
      if (par.b !== h) return;
      var e = ecoCalc(par);
      if (e && (!melhor || e.pct > melhor.pct)) melhor = e;
    });
    return melhor;
  }
  function ecoBadge(e) { return '<span class="av-b av-b--eco">' + esc(tf('eco_badge', { pct: e.pct, u: e.u })) + '</span>'; }

  /* ---------- rotinas ------------------------------------------------------------
     #av-cfg routines: [{k, s:[{st, h, x?, xv?}]}]. st = passo; h = produto;
     x/xv = versao TAMANHO SALAO (1 L) e a variante dela. Sem x, o passo fica
     igual no modo salao. Variante padrao = a disponivel mais barata (o menor
     tamanho) — nunca uma fragrancia ou cor escolhida por nos. */
  var RTS = CFG.routines || [];
  var FAM_RT = { cachos: 'curly', kids: 'kids', tecoil: 'dry', recon: 'damaged', anti: 'breakage', vizu: 'vizu', treat: 'buildup' };
  function rtDef(k) { for (var i = 0; i < RTS.length; i++) if (RTS[i].k === k) return RTS[i]; return null; }
  function rtItem(d, salao) {
    var h = d.h, vid = null;
    if (salao && d.x) {
      var px = porHandle(d.x);
      var vx = px && d.xv ? varPorId(px, d.xv) : (px ? px.min : null);
      if (px && px.av && vx && vx.av) { h = d.x; vid = vx.id; }
    }
    var p = porHandle(h);
    if (!p || !p.av) return null;
    var v = vid ? varPorId(p, vid) : p.min;
    if (!v || !v.av) v = p.min;
    return { st: d.st, p: p, v: v, d: d };
  }
  function rtItens(k, salao) {
    var r = rtDef(k);
    if (!r) return [];
    return r.s.map(function (d) { return rtItem(d, salao); }).filter(Boolean);
  }
  function rtTemSalao(k) {
    var r = rtDef(k);
    return !!r && r.s.some(function (d) { var it = d.x && rtItem(d, true); return it && it.p.h === d.x; });
  }
  /* economia do modo salao da rotina (maior % entre os passos que trocam) */
  function rtEcoSalao(k) {
    var r = rtDef(k), melhor = 0;
    if (!r) return 0;
    r.s.forEach(function (d) {
      if (!d.x) return;
      ECO.forEach(function (par) {
        if (par.s === d.h && par.b === d.x) { var e = ecoCalc(par); if (e && e.pct > melhor) melhor = e.pct; }
      });
    });
    return melhor;
  }
  function rotinaDoProduto(p) {
    var fam = FAM_RT[p.fam];
    var achou = null;
    RTS.forEach(function (r) {
      if (achou && achou === fam) return;
      if (r.s.some(function (d) { return d.h === p.h || d.x === p.h; })) { if (!achou || r.k === fam) achou = r.k; }
    });
    return achou || (rtDef(fam) ? fam : null);
  }
  function noCarrinho(h) { return CART.items.some(function (it) { return it.handle === h; }); }
  function miniHTML(it, extra) {
    var img = (it.p.img[0] || {}).s;
    return '<span class="av-mini__img">' + (img ? '<img src="' + esc(imgW(img, 120)) + '" alt="" width="120" height="120">' : '') + '</span>' +
      '<span class="av-mini__b">' + (it.st ? '<small>' + esc(t('st_' + it.st)) + '</small>' : '') + '<b>' + esc(curto(it.p.t)) + '</b>' +
      (it.p.multi ? '<i>' + esc(it.v.t) + '</i>' : '') + '</span>' +
      '<span class="av-mini__p">' + esc(it.v.prf) + '</span>' + (extra || '');
  }
  /* soma, desconto estimado (contando o carrinho) e total */
  function contaHTML(itens) {
    var n = itens.length, sub = 0, off = 0;
    var pct = pctDe(CART.count + n);
    /* o Pumper arredonda o desconto PARA BAIXO em cada linha (medido no
       checkout em 22/09/2026: 15% de $29,26 = $4,38); moeda sem centavos
       (iene, won) arredonda na unidade */
    var passo = (MF && !MF.dec) ? 100 : 1;
    itens.forEach(function (it) { sub += it.v.pr; off += Math.floor(it.v.pr * pct / 100 / passo) * passo; });
    return '<dl class="av-conta">' +
      '<div><dt>' + esc(t('rb_sub')) + ' (' + n + ')</dt><dd>' + esc(money(sub)) + '</dd></div>' +
      (pct ? '<div class="av-conta__off"><dt>' + esc(t('rb_disc')) + ' · ' + pct + '%</dt><dd>−' + esc(money(off)) + '</dd></div>' : '') +
      '<div class="av-conta__tot"><dt>' + esc(t('rb_total')) + '</dt><dd>' + esc(money(sub - off)) + '</dd></div></dl>' +
      (CART.count ? '<p class="av-nota av-conta__cart">' + esc(tf('rb_incart', { n: CART.count })) + '</p>' : '');
  }
  function msgDegrauHTML(n) {
    var total = CART.count + n, prox = proximoDegrau(total), max = (CFG.steps || []).slice(-1)[0];
    if (!prox) return max ? '<p class="av-tiermsg is-max">' + esc(tf('rb_max', { pct: max.p })) + '</p>' : '';
    return '<p class="av-tiermsg">' + esc(tf('rb_missing', { q: prox.q, pct: prox.p })) + '</p>';
  }

  /* ---------- colocar varios de uma vez ----------------------------------------------
     Um POST so; se a loja recusar o lote (um item esgotou no meio do caminho),
     tenta um por um, para nao perder os outros. */
  function addMany(vids, btn, abrir, msg) {
    vids = (vids || []).map(Number).filter(Boolean);
    if (!vids.length) return Promise.resolve();
    var rotulo = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
    var post = function (items) {
      return fetch(cartURL('/cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); });
    };
    var itens = vids.map(function (id) { return { id: id, quantity: 1 }; });
    var falhou = 0;
    return post(itens).catch(function () {
      return itens.reduce(function (pr, it) {
        return pr.then(function () { return post([it]).catch(function () { falhou++; }); });
      }, Promise.resolve());
    }).then(function () { return fetchCart(); }).then(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = rotulo; }
      if (falhou) toast(t('err_add'));
      else if (abrir) { closePDP(); openCart(); } else toast(msg || t('toast_added'));
    }).catch(function (e) {
      console.error('[arvensis] add varios', e);
      if (btn) { btn.disabled = false; btn.innerHTML = rotulo; }
      toast(t('err_add'));
    });
  }

  /* ==========================================================================
     CARROSSEL DO TOPO
     Passa sozinho a cada 6,5 s; para com o mouse em cima, com foco dentro,
     com a aba escondida, com "reduzir movimento" e no botao de pausa (WCAG
     2.2.2). Setas, pontos e arrastar no celular. Slide cujo produto nao existe
     no mercado sai (conferido depois que o catalogo inteiro chegou).
     ========================================================================== */
  var HERO = null;
  function ligaHero() {
    var hero = $('[data-av-hero]');
    if (!hero) return;
    var slides = $$('[data-av-slide]', hero);
    var ctl = $('[data-av-hero-ctl]', hero), dotsEl = $('[data-av-hero-dots]', hero), pp = $('[data-av-hero-pp]', hero);
    var track = $('[data-av-hero-track]', hero);
    var I = 0, timer = null, parado = false, pausa = false;
    var reduz = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function vis() { return slides.filter(function (s) { return !s.hidden; }); }
    function carrega(s) {
      if (!s) return;
      $$('[data-srcset]', s).forEach(function (el) { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); });
      $$('img[data-src]', s).forEach(function (el) { el.src = el.dataset.src; el.removeAttribute('data-src'); });
    }
    function pintaPontos() {
      var vs = vis();
      if (ctl) ctl.hidden = vs.length < 2;
      if (!dotsEl) return;
      var of = dotsEl.dataset.of || '{i} / {n}';
      dotsEl.innerHTML = vs.map(function (s, i) {
        return '<button type="button" data-av-hero-dot="' + i + '" aria-label="' + esc(of.replace('{i}', i + 1).replace('{n}', vs.length)) + '"' +
          (i === I ? ' aria-current="true"' : '') + '></button>';
      }).join('');
    }
    function mostra(n) {
      var vs = vis();
      if (!vs.length) { hero.hidden = true; return; }
      I = (n + vs.length) % vs.length;
      slides.forEach(function (s) {
        var on = s === vs[I];
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', String(!on));
      });
      carrega(vs[I]);
      pintaPontos();
    }
    function agenda() {
      clearTimeout(timer);
      if (parado || pausa || reduz || D.hidden || vis().length < 2) return;
      timer = setTimeout(function () { mostra(I + 1); agenda(); }, 6500);
    }
    function vai(dir) { mostra(I + dir); agenda(); }
    hero.addEventListener('mouseenter', function () { pausa = true; clearTimeout(timer); });
    hero.addEventListener('mouseleave', function () { pausa = false; agenda(); });
    hero.addEventListener('focusin', function () { pausa = true; clearTimeout(timer); });
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) { pausa = false; agenda(); } });
    D.addEventListener('visibilitychange', agenda);
    hero.addEventListener('click', function (e) {
      var go = e.target.closest && e.target.closest('[data-av-hero-go]');
      if (go) { e.preventDefault(); vai(Number(go.dataset.avHeroGo)); return; }
      var dot = e.target.closest && e.target.closest('[data-av-hero-dot]');
      if (dot) { e.preventDefault(); mostra(Number(dot.dataset.avHeroDot)); agenda(); return; }
      if (e.target.closest && e.target.closest('[data-av-hero-pp]')) {
        e.preventDefault();
        parado = !parado;
        pp.classList.toggle('is-paused', parado);
        pp.setAttribute('aria-label', parado ? pp.dataset.play : pp.dataset.pause);
        agenda();
      }
    });
    /* arrastar (dedo): so no eixo X, para nao brigar com a rolagem da pagina */
    var x0 = null, y0 = null;
    if (track) {
      track.addEventListener('touchstart', function (e) { var p = e.touches[0]; x0 = p.clientX; y0 = p.clientY; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var p = e.changedTouches[0], dx = p.clientX - x0, dy = p.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        var dir = dx < 0 ? 1 : -1;
        if (D.documentElement.dir === 'rtl') dir = -dir;
        vai(dir);
      }, { passive: true });
    }
    /* slides 2 e 3 baixam depois da pagina pronta: o primeiro troca na hora */
    var preCarga = function () { setTimeout(function () { slides.forEach(carrega); }, 1200); };
    if (D.readyState === 'complete') preCarga(); else window.addEventListener('load', preCarga);
    HERO = {
      confere: function () {
        slides.forEach(function (s) { if (s.dataset.avNeed && !porHandle(s.dataset.avNeed)) s.hidden = true; });
        $$('[data-av-hs]', hero).forEach(function (a) { a.hidden = !porHandle(a.dataset.avOpenHandle); });
        mostra(I);
        agenda();
      }
    };
    mostra(0);
    agenda();
  }

  /* ==========================================================================
     MONTE SUA ROTINA
     ========================================================================== */
  var RB = { k: null, salao: false, custom: false, slots: [] };
  var RB_MAX = 4;
  function rbCarrega(k, salao) {
    var r = rtDef(k);
    if (!r) return;
    RB.k = k;
    RB.salao = !!salao && rtTemSalao(k);
    RB.custom = false;
    RB.slots = r.s.map(function (d) { var it = rtItem(d, RB.salao); return it || { st: d.st, p: null, v: null, d: d }; })
      .filter(function (s) { return s.p; });
    while (RB.slots.length < RB_MAX) RB.slots.push({ st: null, p: null, v: null });
    RB.slots = RB.slots.slice(0, RB_MAX);
  }
  function rbCheios() { return RB.slots.filter(function (s) { return s.p; }); }
  function rbPinta() {
    var box = $('[data-av-rb]');
    if (!box || !RB.k) return;
    $$('[data-av-rt]').forEach(function (b) {
      var on = b.dataset.avRt === RB.k;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', String(on));
      b.tabIndex = on ? 0 : -1;
      b.hidden = !rtItens(b.dataset.avRt, false).length;
    });
    var desc = $('[data-av-rb-desc]');
    if (desc) desc.textContent = t('rd_' + RB.k);
    var sw = $('[data-av-rb-salon]');
    if (sw) {
      var tem = rtTemSalao(RB.k), eco = rtEcoSalao(RB.k);
      sw.hidden = !tem;
      sw.setAttribute('aria-checked', String(RB.salao));
      var sm = $('small', sw);
      if (sm) sm.textContent = eco ? tf('eco_badge', { pct: eco, u: 'ml' }) : '';
    }
    var lista = $('[data-av-rb-slots]');
    if (lista) lista.innerHTML = RB.slots.map(function (s, i) {
      if (!s.p) {
        return '<li class="av-slot av-slot--empty"><button type="button" class="av-slot__add" data-av-rb-change="' + i + '"><span aria-hidden="true">+</span>' +
          esc(t('rb_empty')) + '</button></li>';
      }
      var img = (s.p.img[0] || {}).s;
      var eco = !RB.salao && ecoDoPequeno(s.p.h, s.v.id);
      var sel = s.p.multi ? '<select class="av-slot__sel" data-av-rb-var="' + i + '" aria-label="' + esc(s.p.opt && s.p.opt !== 'Title' ? s.p.opt : t('pdp_opt')) + '">' +
        s.p.v.map(function (v) { return '<option value="' + v.id + '"' + (v.id === s.v.id ? ' selected' : '') + (v.av ? '' : ' disabled') + '>' + esc(v.t) + '</option>'; }).join('') +
        '</select>' : '';
      return '<li class="av-slot">' +
        '<span class="av-slot__n">' + (i + 1) + '</span>' +
        (s.st ? '<span class="av-slot__st">' + esc(t('st_' + s.st)) + '</span>' : '<span class="av-slot__st">&nbsp;</span>') +
        '<button type="button" class="av-slot__img" data-av-open-handle="' + esc(s.p.h) + '" aria-label="' + esc(s.p.t) + '">' +
          (img ? '<img src="' + esc(imgW(img, 300)) + '" alt="" loading="lazy" width="300" height="300">' : '') + '</button>' +
        '<b class="av-slot__t">' + esc(curto(s.p.t)) + '</b>' + sel +
        '<span class="av-slot__p">' + esc(s.v.prf) + '</span>' +
        (eco ? '<span class="av-slot__eco">' + ecoBadge(eco) + '</span>' : '') +
        '<span class="av-slot__acts"><button type="button" class="av-lnk" data-av-rb-change="' + i + '">' + esc(t('rb_change')) + '</button>' +
        '<button type="button" class="av-slot__x" data-av-rb-rm="' + i + '" aria-label="' + esc(t('rb_remove') + ': ' + curto(s.p.t)) + '">&times;</button></span>' +
        '</li>';
    }).join('');
    rbResumo();
  }
  function rbResumo() {
    var sum = $('[data-av-rb-sum]');
    if (!sum) return;
    var itens = rbCheios(), n = itens.length;
    sum.innerHTML = degrausHTML(CART.count + n) + msgDegrauHTML(n) + contaHTML(itens) +
      '<button type="button" class="av-btn av-btn--full" data-av-rb-add' + (n ? '' : ' disabled') + '>' + esc(tf('rb_add', { n: n })) + '</button>' +
      '<p class="av-nota">' + esc(t('rb_note')) + '</p>' +
      '<button type="button" class="av-lnk av-rb__clear" data-av-rb-clear' + (n ? '' : ' hidden') + '>' + esc(t('rb_clear')) + '</button>';
  }
  function rbSeleciona(k, salao) {
    if (!rtDef(k)) return;
    rbCarrega(k, salao);
    rbPinta();
  }

  /* ---------- escolher produto para um passo (painel lateral) ---------------------- */
  var CH = { i: 0, f: 'all' };
  var chEl, chVeil;
  function catDe(p) {
    var h = String(p.h);
    if (/shampoo|co-wash/.test(h)) return 'wash';
    if (/leave-in/.test(h)) return 'finish';
    if (/conditioner/.test(h)) return 'cond';
    if (/mask|acidifier/.test(h)) return 'mask';
    return 'finish';
  }
  var ST_CAT = { wash2: 'wash', wash: 'wash', detox: 'wash', cond: 'cond', mask: 'mask', seal: 'mask' };
  function chPinta() {
    var lista = $('[data-av-chooser-list]');
    if (!lista) return;
    $$('[data-av-cf]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.avCf === CH.f)); });
    /* fora da lista: o que ja esta nos OUTROS passos e o proprio produto deste passo */
    var usados = RB.slots.map(function (s) { return s.p ? s.p.h : null; });
    var famRt = null;
    RB.slots.forEach(function (s) { if (s.p && !famRt) famRt = s.p.fam; });
    var ps = PRODUCTS.filter(function (p) {
      return p.av && !kitPuro(p) && usados.indexOf(p.h) < 0 && (CH.f === 'all' || catDe(p) === CH.f);
    }).sort(function (a, b) {
      var fa = a.fam === famRt ? 0 : 1, fb = b.fam === famRt ? 0 : 1;
      return fa - fb || FAMILIAS.indexOf(a.fam) - FAMILIAS.indexOf(b.fam) || ordena(a, b);
    });
    lista.innerHTML = ps.map(function (p) {
      var img = (p.img[0] || {}).s || '';
      var eco = ecoDoGrande(p.h);
      return '<button type="button" class="av-sres" data-av-choose="' + esc(p.h) + '">' +
        '<span class="av-sres__img">' + (img ? '<img src="' + esc(imgW(img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span><b>' + esc(curto(p.t)) + '</b><span>' + precoHTML(p).replace(/<\/?b>/g, '') + '</span>' + (eco ? ' ' + ecoBadge(eco) : '') + '</span></button>';
    }).join('');
  }
  function abrirEscolha(i) {
    chEl = chEl || $('[data-av-chooser]');
    chVeil = chVeil || $('[data-av-chooser-veil]');
    if (!chEl) return;
    CH.i = i;
    var s = RB.slots[i];
    CH.f = (s && s.st && ST_CAT[s.st]) || (s && s.p ? catDe(s.p) : 'all');
    if (!s || !s.st && !s.p) CH.f = 'all';
    chPinta();
    lastFocus = D.activeElement;
    chEl.classList.add('is-on');
    chEl.setAttribute('aria-hidden', 'false');
    if (chVeil) { chVeil.hidden = false; requestAnimationFrame(function () { chVeil.classList.add('is-on'); }); }
    travarRolagem();
    var x = $('[data-av-chooser-close]', chEl);
    if (x) x.focus();
  }
  function fecharEscolha() {
    if (!chEl || !chEl.classList.contains('is-on')) return;
    chEl.classList.remove('is-on');
    chEl.setAttribute('aria-hidden', 'true');
    if (chVeil) { chVeil.classList.remove('is-on'); setTimeout(function () { chVeil.hidden = true; }, 220); }
    destravarRolagem();
    if (lastFocus && lastFocus.focus && D.body.contains(lastFocus)) lastFocus.focus();
  }
  function escolhe(h) {
    var p = porHandle(h);
    if (!p) return;
    var s = RB.slots[CH.i] || {};
    RB.slots[CH.i] = { st: s.st || null, p: p, v: p.min, d: s.d };
    RB.custom = true;
    fecharEscolha();
    rbPinta();
    var alvo = $$('.av-slot')[CH.i];
    if (alvo) { var b = $('[data-av-rb-change]', alvo); if (b) b.focus(); }
  }

  /* ==========================================================================
     QUAL E O SEU CABELO? — 3 perguntas, rotina pronta com o desconto calculado
     Mapa: tipo x incomodo -> rotina. Frizz segue o tipo (ondulado/cacheado,
     crespo; liso vai para Tec Oil); crianca pula a pergunta 2.
     ========================================================================== */
  var QZ = { i: 0, a: {} };
  var QZ_P = [
    { k: 'type', q: 'qz_q1', o: ['wavy', 'coily', 'straight', 'kids'] },
    { k: 'need', q: 'qz_q2', o: ['frizz', 'damaged', 'breakage', 'dry', 'buildup'] },
    { k: 'lvl', q: 'qz_q3', o: ['ess', 'full', 'salon'] }
  ];
  function qzRotina() {
    var a = QZ.a;
    if (a.type === 'kids') return 'kids';
    if (a.need === 'frizz') return a.type === 'coily' ? 'coily' : (a.type === 'straight' ? 'dry' : 'curly');
    return { damaged: 'damaged', breakage: 'breakage', dry: 'dry', buildup: 'buildup' }[a.need] || 'curly';
  }
  function qzPerguntas() { return QZ_P.filter(function (p) { return !(p.k === 'need' && QZ.a.type === 'kids'); }); }
  function qzItens() {
    var k = qzRotina();
    var itens = rtItens(k, QZ.a.lvl === 'salon');
    return QZ.a.lvl === 'ess' ? itens.slice(0, 2) : itens;
  }
  function qzPinta(foco) {
    var box = $('[data-av-quiz]');
    if (!box) return;
    var ps = qzPerguntas();
    if (QZ.i >= ps.length) { qzResultado(box, foco); return; }
    var p = ps[QZ.i];
    var opcoes = p.o.filter(function (o) { return !(o === 'salon' && !rtTemSalao(qzRotina())); });
    box.innerHTML =
      '<div class="av-quiz__bar" aria-hidden="true"><i style="width:' + Math.round(QZ.i / ps.length * 100) + '%"></i></div>' +
      '<fieldset class="av-quiz__q"><legend><small>' + esc(tf('qz_step', { i: QZ.i + 1, n: ps.length })) + '</small>' +
      '<span data-av-qz-h tabindex="-1">' + esc(t(p.q)) + '</span></legend>' +
      '<div class="av-quiz__opts">' + opcoes.map(function (o) {
        return '<button type="button" class="av-quiz__o" data-av-qz="' + p.k + '" data-v="' + o + '" aria-pressed="' + (QZ.a[p.k] === o) + '">' + esc(t('qz_o_' + o)) + '</button>';
      }).join('') + '</div></fieldset>' +
      (QZ.i ? '<button type="button" class="av-lnk av-quiz__back" data-av-qz-back>' + esc(t('qz_back')) + '</button>' : '');
    if (foco) { var h = $('[data-av-qz-h]', box); if (h) h.focus({ preventScroll: true }); }
  }
  function qzResultado(box, foco) {
    var k = qzRotina(), itens = qzItens();
    var vids = itens.map(function (it) { return it.v.id; }).join(',');
    box.innerHTML =
      '<div class="av-quiz__bar" aria-hidden="true"><i style="width:100%"></i></div>' +
      '<div class="av-quiz__res">' +
        '<div class="av-quiz__rh"><small>' + esc(t('qz_res')) + '</small><h3 data-av-qz-h tabindex="-1">' + esc(t('rt_' + k)) + '</h3><p>' + esc(t('rd_' + k)) + '</p></div>' +
        '<ol class="av-mini">' + itens.map(function (it) {
          return '<li><button type="button" class="av-mini__row" data-av-open-handle="' + esc(it.p.h) + '">' + miniHTML(it) + '</button></li>';
        }).join('') + '</ol>' +
        '<div class="av-quiz__sum" data-av-qz-sum>' + degrausHTML(CART.count + itens.length) + contaHTML(itens) + '</div>' +
        '<div class="av-quiz__acts">' +
          '<button type="button" class="av-btn" data-av-add-many="' + vids + '"' + (itens.length ? '' : ' disabled') + '>' + esc(t('hr_add')) + '</button>' +
          '<a class="av-btn av-btn--ghost" href="#av-routine" data-av-qz-edit>' + esc(t('qz_edit')) + '</a>' +
        '</div>' +
        '<p class="av-nota">' + esc(t('qz_note')) + ' ' + esc(t('rb_note')) + '</p>' +
        '<button type="button" class="av-lnk" data-av-qz-redo>' + esc(t('qz_redo')) + '</button>' +
      '</div>';
    if (foco) { var h = $('[data-av-qz-h]', box); if (h) h.focus({ preventScroll: true }); }
  }
  function qzResumoAtualiza() {
    var s = $('[data-av-qz-sum]');
    if (!s) return;
    var itens = qzItens();
    s.innerHTML = degrausHTML(CART.count + itens.length) + contaHTML(itens);
  }

  /* ==========================================================================
     COMPLETE A ROTINA — na ficha (caixinhas marcadas + "adicionar todos") e
     no carrinho (os passos que faltam, cada um com o proprio botao).
     ========================================================================== */
  function sugestoes(p, max) {
    var k = rotinaDoProduto(p);
    if (!k) return [];
    return rtItens(k, false).filter(function (it) {
      return it.p.h !== p.h && !noCarrinho(it.p.h) && !(it.d.x && noCarrinho(it.d.x));
    }).slice(0, max || 3);
  }
  function crHTML(p) {
    var its = sugestoes(p, 3);
    if (!its.length) return '';
    return '<div class="av-cr" data-av-cr><strong>' + esc(t('cr_t')) + '</strong><small>' + esc(t('cr_d')) + '</small>' +
      '<ul>' + its.map(function (it) {
        return '<li><label class="av-mini__row"><input type="checkbox" checked data-av-cr-vid="' + it.v.id + '">' + miniHTML(it) + '</label></li>';
      }).join('') + '</ul>' +
      '<p class="av-cr__tier" data-av-cr-tier></p>' +
      '<button type="button" class="av-btn av-btn--full" data-av-cr-add></button></div>';
  }
  function crAtualiza() {
    var box = $('[data-av-cr]');
    if (!box || !PDP.v) return;
    var marcados = $$('[data-av-cr-vid]', box).filter(function (c) { return c.checked; }).length;
    var n = marcados + (PDP.v.av ? pdpQtd() : 0);
    var pct = pctDe(CART.count + n);
    var tier = $('[data-av-cr-tier]', box);
    if (tier) {
      var prox = proximoDegrau(CART.count + n);
      tier.textContent = pct ? tf('cr_tier', { n: CART.count + n, pct: pct }) : (prox ? tf('cr_next', { q: prox.q, pct: prox.p }) : '');
    }
    var b = $('[data-av-cr-add]', box);
    if (b) { b.textContent = tf('cr_all', { n: n }); b.disabled = !n; }
  }
  function crAdiciona(btn) {
    var box = $('[data-av-cr]');
    if (!box || !PDP.v) return;
    var vids = $$('[data-av-cr-vid]', box).filter(function (c) { return c.checked; }).map(function (c) { return Number(c.dataset.avCrVid); });
    if (PDP.v.av) for (var i = 0; i < pdpQtd(); i++) vids.unshift(PDP.v.id);
    addMany(vids, btn, true);
  }
  /* no carrinho: a rotina que mais aparece nele e o que falta dela */
  function cartCRHTML() {
    if (!CART.items.length || !RTS.length) return '';
    var hs = CART.items.map(function (it) { return it.handle; });
    var melhor = null, pontos = 0;
    RTS.forEach(function (r) {
      var n = r.s.filter(function (d) { return hs.indexOf(d.h) > -1 || (d.x && hs.indexOf(d.x) > -1); }).length;
      if (n > pontos) { pontos = n; melhor = r.k; }
    });
    if (!melhor) return '';
    var falta = rtItens(melhor, false).filter(function (it) {
      return hs.indexOf(it.p.h) < 0 && !(it.d.x && hs.indexOf(it.d.x) > -1);
    }).slice(0, 3);
    if (!falta.length) return '';
    var prox = proximoDegrau(CART.count);
    return '<div class="av-cr av-cr--cart"><strong>' + esc(t('cr_cart')) + '</strong>' +
      (prox ? '<small>' + esc(tf('cr_next', { q: prox.q, pct: prox.p })) + '</small>' : '<small>' + esc(t('cr_d')) + '</small>') +
      '<ul>' + falta.map(function (it) {
        return '<li><div class="av-mini__row">' + miniHTML(it, '<button type="button" class="av-btn av-btn--sm av-btn--ghost av-mini__add" data-av-add="' + it.v.id + '" aria-label="' +
          esc(t('add') + ': ' + curto(it.p.t)) + '">+</button>') + '</div></li>';
      }).join('') + '</ul></div>';
  }
  /* trocar pela versao 1 L no carrinho: tira a linha e poe o grande na mesma quantidade */
  function trocaGrande(key, vid, qtd, btn) {
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
      .then(function () {
        return fetch(cartURL('/cart/add.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: Math.max(1, qtd) }] })
        });
      })
      .then(function () { return fetchCart(); })
      .catch(function (e) { console.error('[arvensis] troca 1 L', e); toast(t('err_add')); return fetchCart(); });
  }

  /* tudo que depende do carrinho, repintado quando ele muda */
  function vendasCarrinho() {
    rbResumo();
    qzResumoAtualiza();
    crAtualiza();
  }
  /* tudo que depende do catalogo, repintado quando chegam as paginas 2..N */
  var CATALOGO_OK = false;
  function vendasCatalogo() {
    if (!RB.k) rbCarrega(RTS.length ? RTS[0].k : null, false);
    else if (!RB.custom) rbCarrega(RB.k, RB.salao);
    rbPinta();
    qzPinta(false);
    if (CATALOGO_OK && HERO) HERO.confere();
  }
  function ligaVendas() {
    ligaHero();
    /* abas das rotinas: setas do teclado como nas abas do WAI-ARIA */
    $$('[data-av-rt]').forEach(function (b) {
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var vis = $$('[data-av-rt]').filter(function (x) { return !x.hidden; });
        var i = vis.indexOf(b);
        var passo = (e.key === 'ArrowRight' ? 1 : -1) * (D.documentElement.dir === 'rtl' ? -1 : 1);
        var alvo = vis[(i + passo + vis.length) % vis.length];
        if (alvo) { e.preventDefault(); rbSeleciona(alvo.dataset.avRt, false); alvo.focus(); }
      });
    });
    D.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      if (el.matches('[data-av-rb-var]')) {
        var s = RB.slots[Number(el.dataset.avRbVar)];
        var v = s && varPorId(s.p, el.value);
        if (v) { s.v = v; RB.custom = true; rbPinta(); }
        return;
      }
      if (el.matches('[data-av-cr-vid]')) crAtualiza();
    });
  }
  /* cliques dos recursos de venda; devolve true quando tratou */
  function vendasClique(e, alvo) {
    var el;
    if ((el = alvo.closest('[data-av-add-many]'))) {
      e.preventDefault(); e.stopPropagation();
      addMany(String(el.dataset.avAddMany).split(','), el, true);
      return true;
    }
    if ((el = alvo.closest('[data-av-rt]'))) { e.preventDefault(); rbSeleciona(el.dataset.avRt, false); return true; }
    if ((el = alvo.closest('[data-av-routine]'))) {
      /* link do menu, do banner ou do rodape: escolhe a aba e deixa a ancora rolar */
      fecharMenu();
      if (rtDef(el.dataset.avRoutine)) rbSeleciona(el.dataset.avRoutine, false);
      return true;
    }
    if ((el = alvo.closest('[data-av-rb-salon]'))) { e.preventDefault(); rbSeleciona(RB.k, !RB.salao); return true; }
    if ((el = alvo.closest('[data-av-rb-change]'))) { e.preventDefault(); abrirEscolha(Number(el.dataset.avRbChange)); return true; }
    if ((el = alvo.closest('[data-av-rb-rm]'))) {
      e.preventDefault();
      var i = Number(el.dataset.avRbRm);
      RB.slots[i] = { st: RB.slots[i].st, p: null, v: null, d: RB.slots[i].d };
      RB.custom = true; rbPinta();
      var nb = $$('.av-slot')[i]; if (nb) { var bb = $('button', nb); if (bb) bb.focus(); }
      return true;
    }
    if ((el = alvo.closest('[data-av-rb-clear]'))) {
      e.preventDefault();
      RB.slots = RB.slots.map(function (s) { return { st: s.st, p: null, v: null, d: s.d }; });
      RB.custom = true; rbPinta();
      return true;
    }
    if ((el = alvo.closest('[data-av-rb-add]'))) {
      e.preventDefault();
      addMany(rbCheios().map(function (s) { return s.v.id; }), el, true, t('rb_added'));
      return true;
    }
    if ((el = alvo.closest('[data-av-cf]'))) { e.preventDefault(); CH.f = el.dataset.avCf; chPinta(); return true; }
    if ((el = alvo.closest('[data-av-choose]'))) { e.preventDefault(); e.stopPropagation(); escolhe(el.dataset.avChoose); return true; }
    if (alvo.closest('[data-av-chooser-close]') || alvo.closest('[data-av-chooser-veil]')) { fecharEscolha(); return true; }
    if ((el = alvo.closest('[data-av-qz]'))) {
      e.preventDefault();
      QZ.a[el.dataset.avQz] = el.dataset.v;
      QZ.i++;
      qzPinta(true);
      return true;
    }
    if (alvo.closest('[data-av-qz-back]')) { e.preventDefault(); QZ.i = Math.max(0, QZ.i - 1); qzPinta(true); return true; }
    if (alvo.closest('[data-av-qz-redo]')) { e.preventDefault(); QZ = { i: 0, a: {} }; qzPinta(true); return true; }
    if (alvo.closest('[data-av-qz-edit]')) { rbSeleciona(qzRotina(), QZ.a.lvl === 'salon'); if (QZ.a.lvl === 'ess') { RB.slots = RB.slots.map(function (s, i) { return i < 2 ? s : { st: s.st, p: null, v: null, d: s.d }; }); RB.custom = true; rbPinta(); } return true; }
    if ((el = alvo.closest('[data-av-cr-add]'))) { e.preventDefault(); crAdiciona(el); return true; }
    if ((el = alvo.closest('[data-av-swap]'))) {
      e.preventDefault();
      trocaGrande(el.dataset.avSwap, el.dataset.to, Number(el.dataset.q) || 1, el);
      return true;
    }
    return false;
  }

  /* ---------- seletores de pais e idioma ---------------------------------------------- */
  function bindPicker(wrap) {
    if (!wrap) return;
    var btn = $('.av-pick__btn', wrap), menu = $('.av-pick__menu', wrap);
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var aberto = !menu.hidden;
      fecharMenus();
      if (aberto) return;
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var atual = $('[aria-current="true"]', menu);
      if (atual) atual.scrollIntoView({ block: 'nearest' });
    });
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function fecharMenus() {
    $$('.av-pick__menu').forEach(function (m) { m.hidden = true; });
    $$('.av-pick__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  /* O pais prefere a janela do app Orbe; a lista nativa fica de reserva.
     mdApp_forceHideOrbe so trava o pop-up AUTOMATICO. */
  function tentarOrbe() {
    try {
      var modal = D.getElementById('md-app-embed__footer-popup');
      if (typeof window.mdApp_openModal === 'function' && modal) { window.mdApp_openModal('md-app-embed__footer-popup'); return true; }
      if (window.mdApp && typeof window.mdApp.openModal === 'function') { window.mdApp.openModal(); return true; }
    } catch (e) { /* segue para a lista nativa */ }
    return false;
  }
  function abrirPais() {
    if (tentarOrbe()) return;
    var btn = $('[data-av-country] .av-pick__btn');
    if (btn) { window.scrollTo(0, 0); btn.click(); }
  }

  /* ---------- faixa de divergencia de mercado --------------------------------------------
     Sinal: regiao do idioma do navegador; na falta, o fuso. SEM SINAL, NAO
     APARECE. So na divergencia — nunca um pop-up em todo acesso. */
  var TZ2CC = {
    'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
    'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'Europe/London': 'GB', 'Europe/Dublin': 'IE',
    'Europe/Lisbon': 'PT', 'Europe/Madrid': 'ES', 'Europe/Paris': 'FR', 'Europe/Berlin': 'DE',
    'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Zurich': 'CH',
    'Europe/Vienna': 'AT', 'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Copenhagen': 'DK',
    'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR', 'Asia/Dubai': 'AE', 'Asia/Riyadh': 'SA', 'Asia/Jerusalem': 'IL',
    'Asia/Qatar': 'QA', 'Asia/Kuwait': 'KW', 'Asia/Bahrain': 'BH', 'Asia/Muscat': 'OM',
    'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ'
  };
  function paisDoNavegador() {
    var langs = navigator.languages || [navigator.language];
    for (var i = 0; i < langs.length; i++) {
      var m = /[-_]([A-Za-z]{2})$/.exec(langs[i] || '');
      if (m) return m[1].toUpperCase();
    }
    try { var tz = Intl.DateTimeFormat().resolvedOptions().timeZone; if (tz && TZ2CC[tz]) return TZ2CC[tz]; } catch (e) { /* sem sinal */ }
    return null;
  }
  function marketHint() {
    var barra = $('[data-av-hint]');
    if (!barra) return;
    try { if (sessionStorage.getItem('av-hint-off') === '1') return; } catch (e) { /* segue */ }
    var atual = String(CFG.country || '').toUpperCase();
    var sinal = paisDoNavegador();
    if (!sinal || !atual || sinal === atual) return;
    var form = D.getElementById('av-country-form');
    var alvo = form ? $('button[value="' + sinal + '"]', form) : null;
    if (!alvo) return; /* a loja nao vende para esse pais: nao oferece nada */
    var nome = $('span', alvo);
    var nomeEl = $('[data-av-hint-name]', barra);
    if (nomeEl) nomeEl.textContent = nome ? nome.textContent : sinal;
    var ir = $('[data-av-hint-go]', barra);
    if (ir) ir.addEventListener('click', function (e) { e.preventDefault(); alvo.click(); });
    var x = $('[data-av-hint-x]', barra);
    if (x) x.addEventListener('click', function () {
      barra.classList.remove('is-on');
      try { sessionStorage.setItem('av-hint-off', '1'); } catch (e) { /* so nesta visita */ }
    });
    barra.classList.add('is-on');
  }

  /* ---------- ligacao ----------------------------------------------------------------------- */
  function init() {
    $$('[data-av-grid]').forEach(function (g) { g.setAttribute('aria-busy', 'true'); });

    cartEl = $('[data-av-cart]'); veilEl = $('[data-av-cart-veil]'); bodyEl = $('[data-av-cart-body]');
    footEl = $('[data-av-cart-foot]'); totalEl = $('[data-av-cart-total]'); countEl = $('[data-av-count]');
    qdEl = $('[data-av-cart-qd]'); shipEl = $('[data-av-cart-ship]');
    pdpOvl = $('[data-av-pdp-ovl]'); pdpBox = $('[data-av-pdp]');
    menuEl = $('[data-av-menu]'); menuVeil = $('[data-av-menu-veil]');

    ligaCabecalho();
    ligaBusca();
    ligaVendas();
    renderGrids();
    ligaVerTodos();
    ligaBarraFamilias();
    bindPicker($('[data-av-lang]'));
    bindPicker($('[data-av-country]'));
    D.body.classList.toggle('av-has-cart', CART.count > 0);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { $$('.av-rail').forEach(atualizaSetas); }, 150);
    });

    var btnPais = $('[data-av-country] .av-pick__btn');
    if (btnPais) btnPais.addEventListener('click', function (e) {
      if (tentarOrbe()) { e.stopImmediatePropagation(); fecharMenus(); }
    }, true);

    D.addEventListener('click', fecharMenus);

    /* Clique global. A ORDEM importa: controles internos da ficha, depois
       botoes de compra, depois o card (que tambem responde ao clique). */
    D.addEventListener('click', function (e) {
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;

      var opt = alvo.closest('[data-av-var]');
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        if (opt.disabled || !PDP.p) return;
        var nova = PDP.p.v.filter(function (v) { return Number(v.id) === Number(opt.dataset.avVar); })[0];
        if (nova) { PDP.v = nova; pintarVariante(); }
        return;
      }
      var passo = alvo.closest('[data-av-pdp-step]');
      if (passo) { e.preventDefault(); e.stopPropagation(); porQtdPDP(pdpQtd() + Number(passo.dataset.avPdpStep)); return; }

      if (vendasClique(e, alvo)) return;

      var add = alvo.closest('[data-av-add]');
      if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add.dataset.avAdd, false, add, add.closest('.av-pdp') ? pdpQtd() : 1); return; }
      var buy = alvo.closest('[data-av-buy]');
      if (buy) { e.preventDefault(); e.stopPropagation(); addToCart(buy.dataset.avBuy, true, buy, buy.closest('.av-pdp') ? pdpQtd() : 1); return; }

      /* menu do celular: fecha antes de a ancora rolar */
      var ir = alvo.closest('[data-av-menu-go]');
      if (ir && !ir.hasAttribute('data-av-open-handle')) { fecharMenu(); }

      /* abrir ficha (card com variante, busca, "Cronograma capilar" do menu).
         Produto fora do mercado: deixa a ancora do link seguir. */
      var abre = alvo.closest('[data-av-open-handle]');
      if (abre) {
        if (porHandle(abre.dataset.avOpenHandle)) { e.preventDefault(); e.stopPropagation(); fecharBusca(); openPDP(abre.dataset.avOpenHandle); }
        else fecharMenu();
        return;
      }
      var termo = alvo.closest('[data-av-term]');
      if (termo) { e.preventDefault(); abrirBusca(termo.dataset.avTerm); return; }

      var card = alvo.closest('.av-card');
      if (card && card.dataset.avHandle) { openPDP(card.dataset.avHandle); return; }

      if (alvo.closest('[data-av-search-open]')) { abrirBusca(); return; }
      if (alvo.closest('[data-av-search-close]') || alvo.closest('[data-av-search-veil]')) { fecharBusca(); return; }
      if (alvo.closest('[data-av-menu-open]')) { abrirMenu(); return; }
      if (alvo.closest('[data-av-menu-close]') || alvo.closest('[data-av-menu-veil]')) { fecharMenu(); return; }
      if (alvo.closest('[data-av-nostock-country]')) { abrirPais(); return; }
      if (alvo.closest('[data-av-cart-open]')) { openCart(); return; }
      if (alvo.closest('[data-av-cart-close]') || alvo.closest('[data-av-cart-veil]')) { closeCart(); return; }
      if (alvo.closest('[data-av-pdp-close]') || alvo === pdpOvl) { closePDP(); return; }

      var th = alvo.closest('[data-av-th]');
      if (th) {
        var i = Number(th.dataset.avTh), main = $('[data-av-main]');
        if (PDP.p && main && PDP.p.img[i]) {
          main.src = imgW(PDP.p.img[i].s, 900);
          main.alt = PDP.p.img[i].a || PDP.p.t;
          $$('[data-av-th]').forEach(function (b) { b.removeAttribute('aria-current'); });
          th.setAttribute('aria-current', 'true');
        }
        return;
      }
      var qty = alvo.closest('[data-av-qty]');
      if (qty) {
        var linhaEl = qty.closest('.av-line');
        var atual = CART.items.filter(function (it) { return it.key === linhaEl.dataset.key; })[0];
        if (atual) changeQty(atual.key, atual.quantity + Number(qty.dataset.avQty));
        return;
      }
      var rm = alvo.closest('[data-av-rm]');
      if (rm) { var l2 = rm.closest('.av-line'); if (l2) changeQty(l2.dataset.key, 0); }
    });

    /* Teclado. O popup da garantia e um checkbox: o Escape fecha SO ele quando
       estiver aberto. <label role="button"> nao responde a Enter/Espaco
       sozinho — o navegador so liga label e controle no clique. */
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var cbx = D.getElementById('av-guar-cbx');
        if (cbx && cbx.checked) { cbx.checked = false; return; }
        if (chEl && chEl.classList.contains('is-on')) { fecharEscolha(); return; }
        closePDP(); closeCart(); fecharBusca(); fecharMenu(); fecharMenus(); return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target;
      if (!el || !el.closest) return;
      var lbl = el.closest('label[for="av-guar-cbx"]');
      if (lbl) { e.preventDefault(); var c = D.getElementById('av-guar-cbx'); if (c) c.checked = !c.checked; return; }
      var card = el.closest('.av-card');
      if (card && card === el && card.dataset.avHandle) { e.preventDefault(); openPDP(card.dataset.avHandle); }
    });

    /* O resto do catalogo e o carrinho descem EM PARALELO, depois da primeira pintura. */
    carregarResto().then(function () { CATALOGO_OK = true; vendasCatalogo(); });
    fetchCart().then(marketHint);

    /* Carrinho RELIDO quando a pessoa volta: pelo botao voltar do checkout
       (pagina restaurada da memoria) ou de outra aba depois de um tempo. */
    var lido = Date.now();
    window.addEventListener('pageshow', function (e) { if (e.persisted) { lido = Date.now(); fetchCart(); } });
    D.addEventListener('visibilitychange', function () {
      if (!D.hidden && Date.now() - lido > 15000) { lido = Date.now(); fetchCart(); }
    });
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
